import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, FlatButton } from 'material-ui';
import { localize } from '../../../i18n';

const NewChatConfigureDialog = (props) => {
  const {
    onCancel,
    t,
    ...rest
  } = props;

  const message = t('Can\'t chat with the guest as there is no phone number associated with the guest');

  const actions = [
    <FlatButton
      key="ok"
      label={t('OK')}
      primary
      onClick={onCancel}
    />,
  ];

  return (
    <Dialog
      {...rest}
      actions={actions}
      title={t('No phone number')}
    >
      <span>{message}</span>
    </Dialog>
  );
};

NewChatConfigureDialog.propTypes = {
  onCancel: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default localize(NewChatConfigureDialog);



// WEBPACK FOOTER //
// ./src/views/chat/components/NewChatConfigureDialog.js